var render = function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"8","height":"16","viewBox":"0 0 8 16"}},[_c('path',{attrs:{"d":"M7.9.8v2.3H6.4c-.8 0-1.1.4-1.1 1V6h2.6l-.5 2.6H5.1v6.6H2.4V8.6H.1V6h2.4V3.8C2.6 2.1 3.7.7 5.7.7c.9 0 1.3 0 2.2.1z","fill":"#6f7685"}})]) };
module.exports = { render: render };


//////////////////
// WEBPACK FOOTER
// ./assets/_img/icons/icon-facebook.svg
// module id = 245
// module chunks = 0